__turbopack_context__.v({
  "favButtonWrap": "styles-module-scss-module__tGOofW__favButtonWrap",
  "filterButton": "styles-module-scss-module__tGOofW__filterButton",
  "filterLabel": "styles-module-scss-module__tGOofW__filterLabel",
  "kurboToolbarButton": "styles-module-scss-module__tGOofW__kurboToolbarButton",
  "leftButtons": "styles-module-scss-module__tGOofW__leftButtons",
  "searchFilter": "styles-module-scss-module__tGOofW__searchFilter",
  "sortButton": "styles-module-scss-module__tGOofW__sortButton",
  "sortLabel": "styles-module-scss-module__tGOofW__sortLabel",
  "tokenCount": "styles-module-scss-module__tGOofW__tokenCount",
  "toolbarRow": "styles-module-scss-module__tGOofW__toolbarRow",
});
